module.exports = __webpack_public_path__ + "img/open-bg-1.642cf05d.png";